import styled from "styled-components";
import {Typography} from "@material-ui/core";

export const TitleSubHeaderStyled = styled(Typography)`
  position: absolute;
`;